import { StudentDataResponse } from '@nrdy-marketing-engine/cart/@types/student-data';
import braintree, { Dropin } from 'braintree-web-drop-in';
import { CartState, Client } from '../../../@types/cart-state';
import createStudent from '../user/create-student';
import getStudents from '../user/fetch-student';
import getPaymentToken from './get-payment-token';
import makePurchase from './make-purchase';

class Payment {
  userClient: Client;
  client: Dropin;
  token: string;

  constructor(userClient: Client) {
    this.userClient = userClient;
  }

  async fetchOrCreateStudent() {
    try {
      const students = await getStudents(this.userClient?.uuid);
      if (students && typeof students !== 'string' && students.length > 0) {
        return students[0];
      }
      return await createStudent(this.userClient);
    } catch (err) {
      throw new Error(
        `Unexpected error, unable to create or fetch student - client_uuid: ${
          this.userClient?.uuid
        }, Error - ${JSON.stringify(err)}`
      );
    }
  }

  async submit(cartState: CartState, students: StudentDataResponse) {
    try {
      const student =
        students && students?.length > 0 ? students[0] : await this.fetchOrCreateStudent();
      const payload = await this.client.requestPaymentMethod();
      if (student) {
        return await makePurchase({ cartState, payload, student });
      }
      throw new Error(
        `Unexpected error, unable to request payment method - ${this.userClient?.uuid}`
      );
    } catch (err) {
      throw err;
    }
  }

  async build() {
    if (!this.token) this.token = await getPaymentToken();
    const paypalButtonStyle = {
      color: 'gold',
      shape: 'rect',
      size: 'responsive',
      tagline: false,
    } as any;

    return new Promise((resolve, reject) => {
      braintree.create(
        {
          authorization: this.token,
          container: '#braintree-container',
          vaultManager: true,
          preselectVaultedPaymentMethod: true,
          card: true,
          venmo: true,
          paypal: {
            flow: 'vault',
            buttonStyle: paypalButtonStyle,
          },
          translations: {
            fieldInvalidForExpirationDate:
              'Invalid expiration date. Please enter a valid expiration date in the format of MM/YY. The expiration date cannot be in the past.',
          },
        },
        (err, client) => {
          if (err) return reject(err);
          this.client = client;
          resolve(this);
        }
      );
    });
  }
}

export default Payment;
